export default {
    'name': 'tooltip2-hover',
    'width': '16',
    'height': '16',
    'viewBox': '0 0 16 16',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M16 7.99999C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 7.99999C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 7.99999ZM9 3.99999C9 4.55228 8.55228 4.99999 8 4.99999C7.44772 4.99999 7 4.55228 7 3.99999C7 3.44771 7.44772 3 8 3C8.55228 3 9 3.44771 9 3.99999ZM7 6.99999C6.44772 6.99999 6 7.4477 6 7.99999C6 8.55227 6.44772 8.99999 7 8.99999V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V7.99999C9 7.4477 8.55228 6.99999 8 6.99999H7Z\' fill=\'#026958\'/>'
}
